import { render } from "./replacement.vue?vue&type=template&id=20e8eb26&scoped=true"
import script from "./replacement.vue?vue&type=script&lang=js"
export * from "./replacement.vue?vue&type=script&lang=js"

import "./replacement.vue?vue&type=style&index=0&id=20e8eb26&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e8eb26"]])

export default __exports__